import type { EditorPreferencesPort } from "../ports.js";

/**
 * Keeps the user's external-editor choice in memory for the life of the process.
 *
 * Used by the preview Worker, which has no home directory to persist to. The
 * preference dialog and toolbar behave correctly within a session; the choice is
 * simply forgotten when the isolate recycles.
 */
export function createMemoryEditorPreferences(): EditorPreferencesPort {
  let editor: string | null = null;

  return {
    get: () => Promise.resolve(editor),
    set: (value: string) => {
      editor = value;
      return Promise.resolve();
    },
  };
}
